import React, { useState, useContext } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import axios from "axios";
import {apiRoutes} from '../../AppSettings';
import { Form } from 'react-bootstrap';
import Spinner from '../shared/Spinner';

const DoctorRegister = () => {

    const history = useHistory();
    const { updateUserState} = useContext(AuthContext); 

    const initialValue = { 
        email: '', 
        password: '', 
        phone: '',
        speciality: '',
        role: 'Doctor',
        firstName: '',
        lastName: ''
    }

    const [registerData, setRegisterData] = useState(initialValue);
    
    const [showSpinner, setShowSpinner] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = e => {
        e.preventDefault();
        setShowSpinner(true);
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        axios.post(apiRoutes.registerDoctor, JSON.stringify(registerData), options)
          .then((response) => {
            if(response.status === 200)
            {
                setShowSpinner(false);
                const data = response.data;
             //   updateUserState(data.token, data.userDetail, true, data.roles[0], data.loggedInUser);
             //   history.push('/doctordashboard');
                setSuccess(true);
                setRegisterData(initialValue);
            }
          }, (error) => {
            console.log(error);
          });
    };

    return (  
        <div className="content">
            <Spinner show={showSpinner}/> 
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-8 offset-md-2">
							<div className="account-content">
								<div className="row align-items-center justify-content-center">
									<div className="col-md-7 col-lg-6 login-left">
										<img src="assets/img/login-banner.png" className="img-fluid" alt="Login Banner" />	
									</div>
									<div className="col-md-12 col-lg-6 login-right">
										<div className="login-header">
											<h3>Doctor Register <Link to={'/register'}>Not a Doctor?</Link> </h3>
										</div>
                                        {
                                           success &&  
                                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                                Thank You for Registering. Please contact <strong>administrator</strong> for approval.
                                            </div>
                                        }
                                        <Form onSubmit={(e) => handleSubmit(e)}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group form-focus">
                                                        <input
                                                            type="text"
                                                            className="form-control floating"
                                                            required
                                                            onChange={e => setRegisterData({ ...registerData, firstName: e.target.value })} />
                                                        <label className="focus-label">First Name</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group form-focus">
                                                        <input
                                                            type="text"
                                                            className="form-control floating"
                                                            required
                                                            onChange={e => setRegisterData({ ...registerData, lastName: e.target.value })} />
                                                        <label className="focus-label">Last Name</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group form-focus">
                                                <input
                                                    type="email"
                                                    className="form-control floating"
                                                    required
                                                    onChange={e => setRegisterData({ ...registerData, email: e.target.value })} />
                                                <label className="focus-label">Email</label>
                                            </div>
                                            <div className="form-group form-focus">
                                                <input
                                                    type="text"
                                                    className="form-control floating"
                                                    required
                                                    onChange={e => setRegisterData({ ...registerData, phone: e.target.value })} />
                                                <label className="focus-label">Mobile</label>
                                            </div>
                                            <div className="form-group form-focus">
                                            <select className="form-control select" required onChange={e => setRegisterData({ ...registerData, speciality: e.target.value })}>
                                                        <option>--Select Speciality--</option>
                                                        <option>Urology</option>
                                                        <option>Neurology</option>
                                                        <option>Orthopedic</option>
                                                        <option>Cardiologist</option>
                                                        <option>Dentist</option>
                                                    </select>
                                            </div>
                                            <div className="form-group form-focus">
                                            <input
                                                type="password"
                                                className="form-control floating"
                                                required
                                                onChange={e => setRegisterData({ ...registerData, password: e.target.value })} />
                                            <label className="focus-label">Create Password</label>
                                            </div>
                                            <div className="text-right">
                                                <Link className="forgot-link" to={'/'}>Already have an account?</Link>
                                            </div>
                                            <button type="submit" className="btn btn-primary btn-block btn-lg login-btn">Signup</button>
                                            <div className="login-or">
                                                <span className="or-line"></span>
                                                <span className="span-or">or</span>
                                            </div>
                                            <div className="row form-row social-login">
                                                <div className="col-6">
                                                    <a href="#" className="btn btn-facebook btn-block"><i className="fab fa-facebook-f mr-1"></i> Login</a>
                                                </div>
                                                <div className="col-6">
                                                    <a href="#" className="btn btn-google btn-block"><i className="fab fa-google mr-1"></i> Login</a>
                                                </div>
                                            </div>
                                        </Form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>		
    );
};
 
export default DoctorRegister;